import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityService } from '@mynexus/mynexus-ui-lib';
import { WCCPermissionsEnum } from '@core/constants/permissions.enum';

@Component({
  selector: 'app-default-wcc',
  templateUrl: './default-wcc.component.html',
  styleUrls: ['./default-wcc.component.scss'],
  standalone: true
})
export class DefaultWoundCareConnectComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly securityService = inject(SecurityService);

  ngOnInit(): void {
    let url = 'wcc/my-admissions';

    if (this.securityService.hasAccess([WCCPermissionsEnum.Admission_Pending_Read])) {
      url = 'wcc/pending-admissions';
    }

    this.router.navigateByUrl(url);
  }
}
